import Button from '@atlaskit/button';
import {
  useAnalytics,
  SendDatabaseSortEventSources,
  sendSortEvent,
} from '@databases/analytics';
import { DatabaseField } from '@databases/types/database';
import { DatabaseViewSettings } from '@databases/types/database/view';
import useView from '@databases/views/useView';
import { getSortIcon } from '@databases/views/utils';
import React, { FunctionComponent, useMemo, useCallback } from 'react';
export interface SortingActionProps {
  field: DatabaseField;
  onChange: (value: DatabaseViewSettings['sort']) => void;
  contentId: string;
}

const SortingAction: FunctionComponent<SortingActionProps> = ({
  field,
  contentId,
  onChange,
}) => {
  const { view } = useView();
  const sortValue = view.settings.sort;
  const client = useAnalytics();

  const handleChange = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      const sortSettings = {
        fieldId: field.id,
        ascending: sortValue?.ascending === false,
      };
      onChange(sortSettings);
      sendSortEvent(
        client,
        sortSettings,
        SendDatabaseSortEventSources.FIELD_NAME,
        field.type,
        contentId
      );
    },
    [field.id, field.type, sortValue?.ascending, onChange, client, contentId]
  );

  const icon = useMemo(
    () => getSortIcon(sortValue?.ascending === true),
    [sortValue?.ascending]
  );

  return (
    <Button
      spacing="compact"
      onClick={handleChange}
      iconBefore={icon}
      appearance="subtle"
    />
  );
};

export default SortingAction;
